import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { LoginPageActions, AuthActions, AuthApiActions } from '../actions';
import { Credentials, UserDto } from '@cradua/data';
import { AuthService } from '../services/auth.service';
import { LogoutConfirmationDialogComponent } from '../components';
import { NotificationService } from "@cradua/core";
import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';

@Injectable()
export class AuthEffects {
	login$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LoginPageActions.login),
			map((action) => action.credentials),
			exhaustMap((auth: Credentials) =>
				this.authService.login(auth).pipe(
					map((user) => {
						console.log('User ', user);

						if (localStorage.getItem('LoggedInUser')) {
							localStorage.removeItem('LoggedInUser');
							localStorage.setItem('LoggedInUser', JSON.stringify(user));

							this.authService.doLoginUser(user.username, { jwt: user.token, refreshToken: '' });
						} else {
							localStorage.setItem('LoggedInUser', JSON.stringify(user));
							this.authService.doLoginUser(user.username, { jwt: user.token, refreshToken: '' });
						}

						this.authService.subject$.next(false);
						this.gatewayService.isLoggedIn$.next(true);

						//console.log("Set Is Logged In to true");

						return AuthApiActions.loginSuccess({ user });
					}),
					catchError((error) => {
						//console.log('error ', error.error.status);
						this.authService.subject$.next(false);
						//this.authService.isLoading$.next(false);
						this.notification.error("Invalid username or password");

						this.router.navigateByUrl('/login');
					//window.location.reload();

						return of(AuthApiActions.loginFailure({ error: error.error.message }));
					})
				)
			)
		)
	);


	loginSSO$ = createEffect(() =>
	this.actions$.pipe(
		ofType(LoginPageActions.loginSSO),
		map((action) => action.credentials),
		exhaustMap((auth: Credentials) =>
			this.authService.loginSSO(auth).pipe(
				map((user) => {
					// console.log('User ', user);

					if (localStorage.getItem('LoggedInUser')) {
						localStorage.removeItem('LoggedInUser');
						localStorage.setItem('LoggedInUser', JSON.stringify(user));

						this.authService.doLoginUser(user.username, { jwt: user.token, refreshToken: '' });
					} else {
						localStorage.setItem('LoggedInUser', JSON.stringify(user));
						this.authService.doLoginUser(user.username, { jwt: user.token, refreshToken: '' });
					}

					this.authService.subject$.next(false);
					this.gatewayService.isLoggedIn$.next(true);

					//console.log("Set Is Logged In to true");

					return AuthApiActions.loginSuccess({ user });
				}),
				catchError((error) => {
					//console.log('error ', error.error.status);
					this.authService.subject$.next(false);
					//this.authService.isLoading$.next(false);
					this.notification.error("Invalid username or password");

					this.router.navigateByUrl('/login');
				//window.location.reload();

					return of(AuthApiActions.loginFailure({ error: error.error.message }));
				})
			)
		)
	)
);

	loginSuccess$ = createEffect(
		() => this.actions$.pipe(ofType(AuthApiActions.loginSuccess), tap(() => {
      console.log('login and redirect to dashboard');
      return this.router.navigate(['/dashboard'])
    })),
		{ dispatch: false }
	);

	// registerSuccess$ = createEffect(


	// 	() => this.actions$.pipe(ofType(AuthApiActions.addUserSuccess), tap(() => this.router.navigate([ '/dashboard' ]))),
	// 	{ dispatch: false }
	// );

	loginRedirect$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AuthApiActions.loginRedirect, AuthActions.logout),
				tap((authed) => {
					localStorage.removeItem('LoggedInUser');
					localStorage.removeItem('Application');
					localStorage.removeItem('AssignedRoles');
					localStorage.removeItem('REFRESH_TOKEN');
					localStorage.removeItem('JWT_TOKEN');
					localStorage.removeItem('Link');
					localStorage.removeItem('userRoles');
					this.gatewayService.isLoggedIn$.next(false);
					this.router.navigateByUrl('/login');
					window.location.reload();
					//this
				})
			),
		{ dispatch: false }
	);

	logoutConfirmation$ = createEffect(() =>
		this.actions$.pipe(
			ofType(AuthActions.logoutConfirmation),
			exhaustMap(() => {
				const dialogRef = this.dialog.open<LogoutConfirmationDialogComponent, undefined, boolean>(
					LogoutConfirmationDialogComponent
				);

				return dialogRef.afterClosed();
			}),
			map((result) => (result ? AuthActions.logout() : AuthActions.logoutConfirmationDismiss()))
		)
	);

	addUser$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LoginPageActions.addUser),
			map((action) => action.user),
			exhaustMap((user: UserDto[]) =>
				this.authService.creatUser(user).pipe(
					map((user) => {

						   // Dispatch Login Action

						   //console.log("User Password Creation", user);

						   let credentials: Credentials = new Credentials();
						   credentials.username = user[0].UserName;
						   credentials.password = user[0].password;
						   credentials.UIN = user[0].UIN;


						  // console.log("User Password Creation", credentials.username, credentials.password);

						//this.authMainService.isLoggedIn$.next(true);
						this.authService.subject$.next(false);

						 if(user[0].UserType === "Subscriber")
						 {
							return LoginPageActions.login({credentials});
						 }else{
                            return	AuthApiActions.addUserSuccess({ user })
						 }

						//return	AuthApiActions.addUserSuccess({ user })
					}),
					catchError((error) => {
						////console.log('error ', error.error.message)
						return of(AuthApiActions.loadUserFailure({ error: error.error.message }));
					})
				)
			)
		)
	);

	loadUsersBySubscriber$ = createEffect(() =>
		this.actions$.pipe(
			ofType(LoginPageActions.LoadUsersBySubscriber),
			exhaustMap((_) =>
				this.authService.getAllUsersBySubscriberId().pipe(
					map((user) => {
						return LoginPageActions.LoadUsersBySubscriberSuccess({ user });
					}),
					catchError((error) => {
						////console.log('error ', error.error.message)
						return of(AuthApiActions.loadUserFailure({ error: error.error.message }));
					})
				)
			)
		)
	);

	// 	addUser$ = createEffect(() =>
	//   this.actions$.pipe(
	//     ofType(LoginPageActions.addUser),
	//     concatMap(({ user }) =>
	//     this.authService.creatUser(user)
	//         .pipe(
	//           map((data) => AuthApiActions.addUserSuccess({ user: data })),
	//           catchError((error) =>
	//             of(AuthApiActions.addUserFailure({ error: error.error.message }))
	//           )
	//         )
	//     )
	//   )
	// );

	//   logoutIdleUser$ = createEffect(() =>
	//     this.actions$.pipe(
	//       ofType(UserActions.idleTimeout),
	//       map(() => AuthActions.logout())
	//     )
	//   );

	constructor(
		private actions$: Actions,
		private authService: AuthService,
		private router: Router,
		private dialog: MatDialog,
		private notification: NotificationService,
		private gatewayService: GatewayService,
	) {}
}
